import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PACKAGES } from "@/data/content";

export const Packages = () => {
  return (
    <section id="pakete" data-testid="packages-section" className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9 }}
        className="mb-14"
      >
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-gold">Pakete — Transparent & kuratiert</p>
        <h2 className="max-w-2xl font-serif text-3xl font-light tracking-tight text-white sm:text-4xl lg:text-5xl">
          Drei Wege, zusammenzuarbeiten. <span className="italic text-zinc-400">Keine versteckten Kosten.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        {PACKAGES.map((pkg, i) => (
          <motion.div
            key={pkg.nr}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            data-testid={`package-card-${pkg.nr}`}
            className={`relative flex flex-col border p-10 transition-all duration-500 hover:-translate-y-1 lg:p-12 ${
              pkg.featured
                ? "border-gold/60 bg-ink2 shadow-[0_30px_80px_rgba(212,175,55,0.08)]"
                : "border-white/10 bg-ink2/40 hover:border-gold/30 hover:bg-ink2"
            }`}
          >
            {pkg.featured && (
              <span className="absolute -top-3 left-8 bg-gold px-3 py-1 font-mono text-[9px] uppercase tracking-[0.25em] text-ink">
                Meistgebucht
              </span>
            )}
            <div className="flex items-baseline justify-between">
              <span className="font-mono text-xs text-zinc-500">{pkg.nr}</span>
              <span className={`font-serif text-2xl ${pkg.featured ? "text-gold" : "text-white"}`}>{pkg.price}</span>
            </div>
            <h3 className="mt-6 font-serif text-3xl text-white">{pkg.name}</h3>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{pkg.tagline}</p>
            <ul className="mt-8 flex-1 space-y-3.5 border-t border-white/10 pt-8">
              {pkg.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-zinc-300">
                  <Check size={14} className="mt-0.5 shrink-0 text-gold" />
                  {f}
                </li>
              ))}
            </ul>
            <button
              data-testid={`package-inquire-${pkg.nr}`}
              onClick={() => scrollToId("#kontakt")}
              className={`group mt-10 flex items-center justify-center gap-3 rounded-full py-3.5 font-mono text-[10px] uppercase tracking-[0.25em] transition-colors ${
                pkg.featured
                  ? "bg-gold text-ink hover:bg-white"
                  : "border border-white/20 text-white hover:border-gold hover:text-gold"
              }`}
            >
              Paket anfragen
              <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>
        ))}
      </div>
      <p className="mt-10 text-center font-mono text-[9px] uppercase tracking-[0.3em] text-zinc-600" data-testid="packages-footnote">
        Inklusive bei jedem Paket: Private Online-Galerie & Druckfreigabe
      </p>
    </section>
  );
};
